import { render, staticRenderFns } from "./DedicatedPlans.vue?vue&type=template&id=7b9838a4"
import script from "./DedicatedPlans.vue?vue&type=script&lang=js"
export * from "./DedicatedPlans.vue?vue&type=script&lang=js"
import style0 from "./DedicatedPlans.vue?vue&type=style&index=0&id=7b9838a4&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports